<template>
  <div class="animated fadeIn">
    <div v-if="!organization.id">
      <p>Organization not found, or you do not have access to this organization in the given Org/Group context.</p>
    </div>
    <div v-if="organization.id">
      <b-form @submit="addOrUpdateOrganizationRecord">
        <b-row>
          <b-col md="9" sm="12" class="mb-4">
            <h3 v-if="_.get(this.organization, 'id', false)" class="card-title mb-0">{{ this.organization.title }}</h3>
            <h3 v-if="!this.organization.id" class="card-title mb-0">Update Organization</h3>
              <div class="small text-muted">Added {{ getOrganizationAddedDate() }}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <OrganizationForm v-bind:organization="organization"></OrganizationForm>
             <b-alert
              fade
              :show="UpdateOrganizationFailure"
              :variant="'danger'">
              <span v-html="UpdateOrganizationFailure">
              </span>
            </b-alert>
            <b-row align-h="end">
              <b-col cols="auto" class="p-3">
                <b-button variant="link" v-bind:href="'/admin/organizations/'+ organization.id" >Cancel</b-button>
                <b-button variant="primary" @click="addOrUpdateOrganizationRecord">Submit</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-form>
         <h2 v-show="UpdateOrganizationPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
    <pulse-loader :loading="UpdateOrganizationPending" color="#489AAC" size="50px"></pulse-loader>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import OrganizationForm from '@/views/t1/Admin/OrganizationForm'

  export default {
    name: 'editorganization',
    components: {
      OrganizationForm
    },
    computed: {
      ...mapGetters({
        organization: 'getEditOrganization',
        UpdateOrganizationFailure: 'getUpdateOrganizationFailure',
        UpdateOrganizationPending: 'getUpdateOrganizationPending',
        UpdateOrganizationSuccess: 'getUpdateOrganizationSuccess'
      }),
      orgId () {
        return this.$route.params.id
      }
    },
    data: function () {
      return {
      }
    },
    watch: {
      UpdateOrganizationSuccess: function (newValue) {
        if (newValue) {
          // Send them back to the view user screen
          this.$router.push({ path: '/admin/organizations/' + newValue.id })
        }
      }
    },
    methods: {
      getOrganizationAddedDate: function () {
        const org = this.organization
        if (org.createdAt) {
          return this.$utils.unixToHuman(org.createdAt / 1000)
        }
        return 'unknown'
      },
      addOrUpdateOrganizationRecord () {
        this.$validator.validate().then(result => {
          if (result) {
            let updatedData = _.pick(this.organization, [
              'id',
              'title',
              'mailingStreet',
              'mailingCity',
              'mailingState',
              'county',
              'mailingStateAbbreviation',
              'mailingPostalCode',
              'defaultLocation',
              'defaultProgram',
              'memberGroups',
              'organizationTypes',
              'licenseDW'
            ])
            updatedData.organizationTypes = JSON.stringify(updatedData.organizationTypes)
            updatedData.title = _.trim(updatedData.title)
            this.$store.dispatch('updatedOrganization', { id: this.orgId, data: updatedData })
            this.$store.commit('resetEditOrg')
          }
        })
      }
    },
    created () {
      this.$store.dispatch('getOrganizationEdit', { id: this.orgId })
    },
    beforeDestroy () {
      this.$store.commit('resetEditOrg')
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/t1/Admin/EditOrganization.vue